import React, { useContext, useState, Fragment } from 'react';
import { Grid, withStyles } from '@material-ui/core';
// import Lottie from "lottie-react";
import DataContext from '../../data/DataContext';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  leftContainer: {
    justifyContent: 'flex-start',
    // maxWidth:"75%"
  },
  rightContainer: {
    justifyContent: 'flex-end',
  },
  leftMessage: {
    // backgroundColor: "white",
    // boxShadow: "0px 12px 12px rgba(194, 194, 194, 0.58)",
    // fontWeight: "300",
  },
  rightMessage: {
    // backgroundColor: theme.color.message.background,
    // margin: "8px 10px",
    boxShadow: 'none',
  },
  message: {
    fontSize: theme.font.size15, // "15px",
    borderRadius: '0.75rem',
    flexWrap: 'wrap',
    color: theme.color.message.color,
    padding: '0.125rem 1.125rem 0.1875rem',
    maxWidth: '75%',
    zIndex: 10,
    wordWrap: 'break-word',
    wordBreak: 'break-word',
  },
  text: {
    padding: '0.75rem 1rem',
    lineHeight: '1.43',
    borderRadius: '0.625rem',
    backgroundColor: theme.color.message.background,
    fontFamily: 'inherit',
    fontSize: theme.font.size14, //"14px",
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#000',
  },
  buttons: {
    display: 'flex',
    padding: '0rem 1rem',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  buttonIcon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '2rem',
    height: '2rem',
    marginRight: '0.75rem',
  },
  menuIcon: {
    width: '2.5rem',
    height: '2.5rem',
  },
  listbutton: {
    paddingLeft: '1.25rem',
    width: '100%',
    // minWidth: "calc(50% - 0.375rem)",
    // margin: "0.1875rem",
    border: '0',
    borderRadius: '0.375rem',
    boxShadow: '0 0.125rem 0.375rem 0 rgba(0, 0, 0, 0.1)',
    backgroundColor: '#fff',
    display: 'flex',
    // justifyContent: "center",
    alignItems: 'center',
    height: '6rem',
    cursor: 'pointer',
  },
  containerLeft: {
    paddingRight: '0.375rem',
  },
  containerRight: {
    paddingLeft: '0.375rem',
  },
  title: {
    padding: '0.75rem 0rem 0.375rem 0rem',
    fontFamily: 'inherit',
    fontSize: theme.font.size15, //"15px",
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.2',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#000',
  },
  buttonLabel: {
    fontFamily: 'inherit',
    fontSize: theme.font.size14, //"14px",
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.29',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#000',
    paddingRight: '0.3125rem',
  },
  sgBtnBox: {
    marginBottom: '0.375rem',
  },
  privacy: {
    padding: '1rem',
    color: '#666',
    fontSize: theme.font.size12,
  },
});

const SGButton = withStyles(styles)((props) => {
  const { classes, data } = props;
  const [buttonVisible, setButtonVisible] = useState(true);
  const context = useContext(DataContext);
  const handleClick = (button) => {
    // setButtonVisible(false);
    const parameters = button?.parameters;
    const expect = button?.expect;
    context.request(context, button.label, 'button', parameters, expect);
  };
  const buttonFirst = data.buttons[0];
  const buttonSecond = data.buttons[1];

  return (
    <div className={classes.buttons}>
      <Grid container>
        {buttonVisible && (
          <>
            <Grid className={classes.containerLeft} item xs={6}>
              <button
                key={`sgiclo_btn_2`}
                className={`${classes.listbutton}`}
                disabled={context.conversationEnd}
                onClick={() => handleClick(buttonFirst)}
                aria-label={`${buttonFirst.label}, 1 / 2`}
              >
                <div className={classes.buttonIcon}>
                  {buttonFirst.icon_code && (
                    <img
                      src={`/image/${buttonFirst.icon_code}.svg`}
                      className={classes.menuIcon}
                      alt=""
                    />
                  )}
                </div>
                <div className={classes.buttonLabel}>{buttonFirst.label}</div>
              </button>
            </Grid>
            <Grid className={classes.containerRight} item xs={6}>
              <button
                key={`sgiclo_btn_1`}
                className={`${classes.listbutton}`}
                disabled={context.conversationEnd}
                onClick={() => handleClick(buttonSecond)}
                aria-label={`${buttonSecond.label}, 2 / 2`}
              >
                <div className={classes.buttonIcon}>
                  {buttonSecond.icon_code && (
                    <img
                      src={`/image/${buttonSecond.icon_code}.svg`}
                      className={classes.menuIcon}
                      alt=""
                    />
                  )}
                </div>
                <div className={classes.buttonLabel}>{buttonSecond.label}</div>
              </button>
            </Grid>
          </>
        )}
      </Grid>
    </div>
  );
});
function SGICLO(props) {
  const { classes, data } = props;
  return (
    <Fragment>
      <div
        className={[
          classes.root,
          data.mine ? classes.rightContainer : classes.leftContainer,
        ].join(' ')}
      >
        <div
          className={[
            classes.message,
            data.mine ? classes.rightMessage : classes.leftMessage,
          ].join(' ')}
        >
          {data.text && data.text.length && (
            <div role={'text'} className={classes.text}>
              {data.text.split('\n').map((content, key) => (
                <Fragment key={key}>
                  {content}
                  <br />
                </Fragment>
              ))}
            </div>
          )}
          {data.title && data.title.length && (
            <div className={classes.title}>{data.title}</div>
          )}
        </div>
      </div>
      <div className={classes.sgBtnBox}>
        <SGButton data={data}></SGButton>
      </div>
      {/* 챗봇 인사멘트시 개인정보 입력에 대한 주의사항 표기의 건 24-08 */}
      <div className={classes.privacy}>
        대화 시 개인정보를 포함한 민감한 정보는 노출하지 않도록 유의해 주세요.
      </div>
    </Fragment>
  );
}
export default withStyles(styles)(SGICLO);
